import{jsxs as n,jsx as e}from"react/jsx-runtime";import i from"styled-components";import{ChannelSwitcher as r}from"../../channelSwitcher/ChannelSwitcher.js";import{withTranslations as o}from"../../../services/translations/withTranslations.js";import{DEFAULT_PHONE_RATIO as t}from"../deviceFrameArgConstants.js";import{PhoneWrapper as d}from"../PhoneWrapper.js";const a=i.div`
  width: 100%;
`,h=i.div`
  padding: 16px;
  display: inline-block;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`,l=i.div`
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 0 0 16px #f3f2f2;
  flex-grow: 1;
`,s=i.div`
  margin-bottom: 20px;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.05);
`,c=o((({children:i,channelSwitcher:o,channel:c,enabledChannels:p,ratio:m=t,onChannelSwitched:x})=>n(a,{children:[o&&e(s,{children:e(r,{channel:c,enabledChannels:p,onChannelSwitched:x})}),e(d,{ratio:m,children:e(h,{children:e(l,{children:i})})})]})));export{c as StandardPhoneFrame};
//# sourceMappingURL=StandardPhoneFrame.js.map
